import {
  Autocomplete,
  AutocompleteProps,
  AutocompleteRenderGetTagProps,
  Box,
  ListItemIcon,
  ListItemText,
  styled,
} from '@mui/material'
import { UserAvatar } from './UserAvatar'
import { notProp, orUndef } from '@portal/pkg-utils'
import { MultiUserTags } from './MultiUserTags'
import { DisplayableUser } from './model'
import * as React from 'react'

export interface MultiUserSelectProps extends AutocompleteProps<
  DisplayableUser,
  true,
  false,
  false
> {
  compact?: boolean
  label?: string
}

const Root = styled(Autocomplete, {
  label: 'MultiUserSelect',
  slot: 'Root',
  shouldForwardProp: notProp('compact'),
})<MultiUserSelectProps>({}) as React.ComponentType<MultiUserSelectProps>

export const MultiUserSelect: React.FC<MultiUserSelectProps> = (props) => {
  return (
    <Root
      multiple
      {...props}
      getOptionLabel={(option) => option.displayName}
      isOptionEqualToValue={(option, value) => option.identifier === value.identifier}
      renderValue={(value, getItemProps) => (
        <MultiUserTags
          users={value}
          getTagProps={getItemProps as unknown as AutocompleteRenderGetTagProps}
          size={orUndef(props.size && props.size === 'small' && 'small')}
          compact={props.compact}
          readOnly={props.readOnly}
        />
      )}
      getOptionDisabled={props.getOptionDisabled ?? ((option) => !option.active || !option.enabled)}
      renderOption={({ key, ...optionProps }, option: DisplayableUser) => (
        <Box component="li" key={key} {...optionProps} sx={{ py: 0 }}>
          <ListItemIcon sx={{ minWidth: 28 }}>
            <UserAvatar {...option} size={props.size} />
          </ListItemIcon>
          <ListItemText primary={option.displayName} />
        </Box>
      )}
    />
  )
}
